<template>
    <div class="likedisplay-satisfaction">
        <TopOptBar @change="changeSearch" />
        <div class="likedisplay-content">
            <DataOverview :dates="dates" @dateChange="dateChange" />
            <div class="table-content">
                <ChannelTable />
                <FaqTable />
                <SatisfyChart />
                <DisLikeChart />
            </div>
        </div>
    </div>
</template>

<script>
import TopOptBar from "./components/TopOptBar.vue";
import DataOverview from "./components/DataOverview.vue";
import ChannelTable from "./components/ChannelTable.vue";
import FaqTable from "./components/FaqTable.vue";
import SatisfyChart from "./components/SatisfyChart.vue";
import DisLikeChart from "./components/DisLikeChart.vue";

export default {
    components: {
        TopOptBar,
        DataOverview,
        ChannelTable,
        FaqTable,
        SatisfyChart,
        DisLikeChart,
    },
    data() {
        return {
            dates: [],
        }
    },
    mounted() {
        this.queryData();
    },
    beforeDestroy() {
        this.$store.commit("zhiji/resetLikePage");
    },
    watch: {
        filter: {
            handler: function() {
                this.queryData();
            },
            deep: true,
        },
    },
    computed: {
        filter() {
            return this.getStorePorp("filter");
        },
    },
    methods: {
        queryData() {
            this.$store.commit("zhiji/resetLikePage");
            this.$store.dispatch("zhiji/queryLikeStatistic");
            this.$store.dispatch("zhiji/queryLikeQuestion");
            this.$store.dispatch("zhiji/queryLikeQuestionSet");

            this.$store.dispatch("zhiji/querySatisfactionTrend");
            this.$store.dispatch("zhiji/queryDislikeHistogram");
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.likeDisplaySatis[propName];
        },
        dateChange() {
            this.queryData();
        },
        changeSearch(formData) {
            this.curPage = 1;
            this.queryData(formData);
        },
    },
};
</script>

<style lang="less" scoped>
.likedisplay-satisfaction {
    background-color: #f2f7fb;
    min-height: 100%;
    .likedisplay-content {
        padding: 16px;
        .table-content {
            display: flex;
            flex-wrap: wrap;
            margin-top: 16px;
            >div {
                width: calc(50% - 8px);
                margin-right: 8px;
                &:nth-child(2n) {
                    margin-right: 0;
                }
            }
            // justify-content: space-between;
        }
    }

    /deep/.el-date-editor--daterange.el-input__inner {
        width: 220px;
        .el-range__close-icon {
            display: none;
        }
    }
}
</style>
